<div class="d-none d-lg-block">
  <app-lcl-card [cardTitle]="'PORT_CHARGES'" [cardStyle]="enumLclCardStyle.LIGHT">
    <ng-container header-label>
      <app-hint-tooltip-icon [isHideCircle]="true" [isShowCustom]="true" [isSkipMobileModal]="true" [hint]="incotermsHeaderHint">
        <ng-container hint-container>
          <div class="incoterms-label-header">
            {{ incotermsHeaderLabel | translate }}
          </div>
        </ng-container>
      </app-hint-tooltip-icon>
    </ng-container>

    <ng-container header-actions-button>
      <app-switch-button
        [control]="shippingRoleControl"
        [textLeft]="'IMPORT' | translate"
        [textRight]="'LABELS.EXPORT' | translate"
        [isLeftActive]="isLeftSwitchActive"
        [isRightActive]="isRightSwitchActive"
      ></app-switch-button>
    </ng-container>

    <ng-container body>
      <div class="incoterms-items">
        <lcl-incoterms-items
          [incotermsControl]="incotermsControl"
          [currentShippingRole]="currentShippingRole"
          (changeIncotermsSource)="changeIncotermsSource.emit($event)"
        ></lcl-incoterms-items>
      </div>
    </ng-container>
  </app-lcl-card>
</div>

<div class="d-lg-none">
  <div class="incoterms-mobile-wrapper">
    <div class="incoterms-mobile-header">
      <div class="incoterms-mobile-header-top">
        <span class="incoterms-mobile-header-top-text">{{ "PORT_CHARGES" | translate }}</span>

        <app-hint-tooltip-icon [hint]="enumHintKey.incotermsHint"></app-hint-tooltip-icon>
      </div>
      <div class="incoterms-mobile-header-bottom">
        <app-switch-button
          [control]="shippingRoleControl"
          [textLeft]="'IMPORT' | translate"
          [textRight]="'LABELS.EXPORT' | translate"
          [isLeftActive]="isLeftSwitchActive"
          [isRightActive]="isRightSwitchActive"
        ></app-switch-button>

        <app-hint-tooltip-icon [isHideCircle]="true" [isShowCustom]="true" [hint]="incotermsHeaderHint">
          <ng-container hint-container>
            <div class="incoterms-label-header">
              {{ incotermsHeaderLabel | translate }}
            </div>
          </ng-container>
        </app-hint-tooltip-icon>
      </div>
    </div>

    <div class="incoterms-mobile-body">
      <div class="incoterms-items-mobile">
        <lcl-incoterms-items
          [isHighlighted]="true"
          [incotermsControl]="incotermsControl"
          [currentShippingRole]="currentShippingRole"
          (changeIncotermsSource)="changeIncotermsSource.emit($event)"
        ></lcl-incoterms-items>
      </div>
    </div>
  </div>
</div>
